import React, { useState, useLayoutEffect } from 'react';

import CompanyTagChip from 'application/components/CompanyTagChip';

import { DropdownItemDataType } from '@zvuk-b2b/react-uikit/ui/Dropdown';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { TEXTS } from '../texts';

import styles from './index.module.scss';

export type CompanyTagsListProps = {
  selectedTags: DropdownItemDataType[];
  onDisableTag: (tag: DropdownItemDataType) => void;
  visibleTitleLength: number;
  moreTagsCount: number;
  showAllTags: boolean;
  expandCallback: (value: boolean) => void;
  clearAll: () => void;
};

const CompanyTagsList = ({
  selectedTags,
  onDisableTag,
  visibleTitleLength,
  moreTagsCount,
  showAllTags,
  expandCallback,
  clearAll,
}: CompanyTagsListProps) => {
  const [showAll, setShowAll] = useState<boolean>(showAllTags);

  useLayoutEffect(() => {
    setShowAll(showAllTags);
  }, [showAllTags]);

  const switchExpandedState = () => {
    expandCallback(!showAll);
  };

  const resetFilters = () => {
    clearAll();
  };

  return (
    <>
      {selectedTags.map((tag) => (
        <CompanyTagChip
          key={tag.key}
          id={`current_filter_tag_${tag.key}`}
          title={tag.value || ''}
          onRemoveClick={() => {
            onDisableTag(tag);
          }}
          visibleTitleLength={visibleTitleLength}
          chipClassName={styles.CompanyTagsListTag}
        />
      ))}

      {!showAll && moreTagsCount > 0 && (
        <Button
          type={ButtonType.PLAIN}
          elementId="company_tags_expand_button"
          className={styles.CompanyTagsListButtonMore}
          onClick={switchExpandedState}>
          {TEXTS.EXPAND_TAGS(moreTagsCount)}
        </Button>
      )}

      {showAll && selectedTags.length > 0 && (
        <Button
          type={ButtonType.PLAIN}
          elementId="company_tags_hide_button"
          className={styles.CompanyTagsListButtonHide}
          onClick={switchExpandedState}>
          {TEXTS.HIDE_TAGS}
        </Button>
      )}

      {selectedTags.length > 0 && (
        <Button
          type={ButtonType.PLAIN}
          onClick={resetFilters}
          className={styles.CompanyTagsListButtonHide}
          elementId="company_tags_clear_button">
          {TEXTS.CLEAR_TAGS}
        </Button>
      )}
    </>
  );
};

export default CompanyTagsList;
